<div class="step-indicator flex bg-white rounded-full p-2.5">
  <div
    class="dot w-1.5 h-1.5 rounded-full"
    *ngFor="let _ of arr(); let i = index"
    [class.ml-1]="i > 0"
    [class.active]="activeStep === i"
  ></div>
</div>
